import { Ulid } from "@kase/my-marathon-communication";
import { signal } from "@preact/signals";
import { ApiSliceParams } from "../interfaces";
import { Status } from "./interfaces";

const stat = (low: bigint, name: string) => ({
    _id: Ulid.fromLoHi({
        low,
        high: 0n,
    }),
    id: `${low}`,
    name,
});

export const makeStatus = ({}: ApiSliceParams) => {
    const TODO = stat(1n, "To do");
    const IN_PROGRESS = stat(2n, "In Progress");
    const IDLE = stat(3n, "Idle");
    const DONE = stat(4n, "Done");
    const statuses = signal<Status[]>([TODO, IN_PROGRESS, IDLE, DONE]);

    return { statuses, TODO, IN_PROGRESS, IDLE, DONE };
};
